"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDevices = void 0;

var React = _interopRequireWildcard(require("react"));

var _iconFactory = _interopRequireDefault(require("./utils/iconFactory"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Devices = (_ref) => {
  let color = _ref.color,
      baseColor = _ref.baseColor,
      baseColor1 = _ref.baseColor1,
      detailsColor = _ref.detailsColor,
      detailsColor1 = _ref.detailsColor1,
      baseColor2 = _ref.baseColor2,
      _ref$detailsColor = _ref.detailsColor2,
      detailsColor2 = _ref$detailsColor === void 0 ? '#fff' : _ref$detailsColor,
      rest = _objectWithoutProperties(_ref, ["color", "baseColor", "baseColor1", "detailsColor", "detailsColor1", "baseColor2", "detailsColor2"]);

  return (0, _core.jsx)("svg", _extends({}, rest, {
    fill: color
  }), (0, _core.jsx)("path", {
    className: "cr-icon__base cr-icon__base-1",
    fill: baseColor || baseColor1,
    d: "M8 16V4.999A.998.998 0 0 0 7.003 4H5V1.994C5 .893 5.9 0 6.992 0h7.016C15.108 0 16 .895 16 1.994v12.012C16 15.107 15.1 16 14.008 16H8zM0 5.996C0 5.446.438 5 1.003 5h4.994A.999.999 0 0 1 7 5.996v9.008c0 .55-.438.996-1.003.996H1.003A.999.999 0 0 1 0 15.004V5.996z"
  }), (0, _core.jsx)("path", {
    className: "cr-icon__details cr-icon__details-2",
    fill: detailsColor || detailsColor2,
    d: "M8 14V4.999A.998.998 0 0 0 7.003 4H6V2h9v12H8zM1 7h5v7H1V7z",
    opacity: ".7"
  }));
};

const NextIcon = (0, _iconFactory.default)(Devices, 'IconDevices');
exports.IconDevices = NextIcon;